// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { AddressResponse } from './address-response';

// @ts-ignore
import { PersonNameResponse } from './person-name-response';

/** See com.rev360.pms.api.controller.insurance.PersonInsurancePolicyResponse */
/* istanbul ignore next */
@GandalfModel
export class PersonInsurancePolicyResponse extends GandalfModelBase {

	@GandalfProperty({ designType: Number })
	coInsurancePercentage!: number | null;

	@GandalfProperty({ designType: AddressResponse })
	companyAddress!: AddressResponse | null;

	@GandalfProperty({ designType: Number })
	companyDefaultInsuranceTypeReferenceId!: number | null;

	@GandalfProperty({ designType: Number })
	companyDefaultPriorityReferenceId!: number | null;

	@GandalfProperty({ designType: Number })
	companyId!: number | null;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	contactLensAllowance!: number | null;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	contactLensFittingCoPay!: number | null;

	@GandalfProperty({ designType: Date })
	effectiveDate!: Date | null;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	familyDeductible!: number | null;

	@GandalfProperty({ designType: Number })
	feeScheduleId!: number | null;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	generalCoPay!: number | null;

	@GandalfProperty({ designType: String })
	groupNumber!: string | null;

	@GandalfProperty({ designType: Number })
	id!: number | null;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	materialCoPay!: number | null;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	maxFrameAllowance!: number | null;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	medicalExamCoPay!: number | null;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	minFrameAllowance!: number | null;

	@GandalfProperty({ designType: PersonNameResponse })
	personNameResponse!: PersonNameResponse | null;

	@GandalfProperty({ designType: Date })
	policyHolderDob!: Date | null;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	routineExamCoPay!: number | null;

	@GandalfProperty({ designType: String })
	rxBinNumber!: string | null;

	@GandalfProperty({ designType: String })
	rxPcnNumber!: string | null;

	@GandalfProperty({ designType: Date })
	termedDate!: Date | null;

}
